/** Tailwind class string for outline-style destructive action buttons. */
export const DESTRUCTIVE_BUTTON_CLASS =
  "border-destructive/30 text-destructive hover:border-destructive hover:bg-destructive/10 hover:text-destructive";

/** Safe JSON parse that returns a discriminated result instead of throwing. */
export function tryParseJson(
  s: string,
): { ok: true; value: unknown } | { ok: false; error: string } {
  try {
    return { ok: true, value: JSON.parse(s) };
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : "Invalid JSON" };
  }
}
